import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCMxwUV77bYCHCTlwmY0YsBBFWymzvPwyY",
  authDomain: "balaji-lotter.firebaseapp.com",
  projectId: "balaji-lotter",
  storageBucket: "balaji-lotter.firebasestorage.app",
  messagingSenderId: "982567797435",
  appId: "1:982567797435:web:0cdb8d33906ba7b0b1df9e",
  measurementId: "G-S19LY201Z3"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);